import createPlugin from "./createPlugin";

import VideoCarouselRenderer from "./Renderer/VideoCarouselRenderer";
import VideoCarouselForm from "./Form/VideoCarouselForm";

const videoPlugin = (settings) =>
    createPlugin({
        Renderer: VideoCarouselRenderer,
        Controls: VideoCarouselForm,
        ...settings,
    });

const videos = videoPlugin();
export default videos;

export { videoPlugin, VideoCarouselRenderer };
